/* lua.js generated code 0.3.0 */

PanelScaleAnim = {}
PanelScaleAnim.popup = function (basePanel, time, centerPos, fromScale, callback) {
    if (!basePanel || !basePanel.nodeExist) {
        return 
    }
    var size = basePanel.getContentSize()
    var targetScale = basePanel.getScale()
    var oneScalePos = cc.p(centerPos.x - size.width / 2, centerPos.y + size.height / 2)
    var fromPos = cc.pAdd(centerPos, cc.pMul(cc.pSub(oneScalePos, centerPos), fromScale))
    var targetPos = cc.pAdd(centerPos, cc.pMul(cc.pSub(oneScalePos, centerPos), targetScale))
    basePanel.setScale(fromScale)
    basePanel.setPosition(fromPos)
    basePanel.runAction(cc.Sequence.create(cc.Spawn.create(cc.EaseSineOut.create(cc.ScaleTo.create(time, targetScale)), cc.EaseSineOut.create(cc.MoveTo.create(time, targetPos))), cc.CallFunc.create(function () {
        if (callback) {
            callback()
        }
    })))
}
PanelScaleAnim.remove = function (basePanel, time, centerPos, callback) {
    if (!basePanel || !basePanel.nodeExist) {
        return 
    }
    basePanel.runAction(cc.Sequence.create(cc.Spawn.create(cc.EaseSineIn.create(cc.ScaleTo.create(time, 0)), cc.EaseSineIn.create(cc.MoveTo.create(time, centerPos))), cc.CallFunc.create(function () {
        if (callback && type(callback) === "function") {
            callback()
        }
    })))
}
